import React from 'react'
import ReactModal from 'react-modal'
import { Form } from 'react-bootstrap'
import CloseBtn from '../../buttons/CloseBtn'
import RequieredInputs from '../../common/RequiredInputs'
import { BusinessUnitMultiSelect } from '../../fields'

const EditCategoriesModal = ({
  modalIsOpen,
  closeModal,
  editCategories,
  handleChange,
  handleSubmit,
  validateForm,
  textBtn,
}) => {
  const customStyles = {
    content: {
      width: '60%',
    },
  }

  return (
    <ReactModal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel='Editar categoria'
      className='custom-modal'
      ariaHideApp={false}
      style={customStyles}
    >
      <span className='custom-modal__close close-btn' onClick={closeModal}>
        <CloseBtn />
      </span>
      <h4 className='custom-modal__title'>Editar categoría</h4>
      <Form className='products__form'>
        <div>
          <Form.Group controlId='product-name'>
            <Form.Label className='form__labels'>
              Nombre <RequieredInputs />{' '}
            </Form.Label>
            <Form.Control
              className='user-input name'
              type='text'
              name='nombre'
              value={editCategories.nombre}
              onChange={handleChange}
              placeholder='Introduce el nombre de la categoría'
            />
          </Form.Group>
        </div>

        <div>
          <BusinessUnitMultiSelect
            value={editCategories.businessUnits || []}
            onChange={(selectedIds) =>
              handleChange({
                target: {
                  name: 'businessUnits',
                  value: selectedIds,
                },
              })
            }
            label='Unidades de Negocio'
            placeholder='Selecciona las unidades de negocio para esta categoría...'
            required
          />
        </div>

        <div className='container__buttons'>
          <button
            onClick={handleSubmit}
            disabled={!validateForm()}
            className='btn save create'
          >
            {textBtn}
          </button>
        </div>
      </Form>
    </ReactModal>
  )
}

export default EditCategoriesModal
